import { render, staticRenderFns } from "./LinkTenantSettingChangeAdmin.vue?vue&type=template&id=9fa765ea&scoped=true"
import script from "./LinkTenantSettingChangeAdmin.vue?vue&type=script&lang=js"
export * from "./LinkTenantSettingChangeAdmin.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSettingChangeAdmin.vue?vue&type=style&index=0&id=9fa765ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa765ea",
  null
  
)

export default component.exports